import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { AppointmentsByPerson } from './appointments-by-person'

export class SchedulerReportsRepository extends BaseRepository<AppointmentsByPerson> {
    private configS: ConfigService

    constructor(
        config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.schedulerApi + '/reports', token, cache)
        this.configS = config
    }

    // Comparecimentos e faltas por pessoa, agregados no banco. Espelha o
    // /reports/invoices/persons/all do pos-api.
    //
    // Não use /appointments para isso: ele traz items, resources e consumption aninhados e tem
    // pageSize fixo em 10.000 com ordenação ascendente — acima do teto devolve os registros
    // MAIS ANTIGOS, em silêncio, e a conta sai invertida.
    async appointmentsByPerson(from: Date, to: Date): Promise<AppointmentsByPerson[]> {
        const url =
            this.configS.schedulerApi +
            '/reports/appointments/persons?from=' +
            new Date(from).toISOString() +
            '&to=' +
            new Date(to).toISOString() +
            '&token=' +
            this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
